import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { TriviaLeaderboardHeader } from './Header';
import { TriviaLeaderboardContent } from './Content';

export class TriviaLeaderboardComponent extends PureComponent {
  static propTypes = {
    myAvatar: PropTypes.string,
    myPosition: PropTypes.number,
    myScore: PropTypes.number,
  };

  static defaultProps = {
    myAvatar: '',
    myPosition: -1,
    myScore: 0,
  };

  render() {
    const { myAvatar, myPosition, myScore, leaderboardData, ...props } = this.props;

    return (
      <Fragment>
        <TriviaLeaderboardHeader
          myAvatar={myAvatar}
          myPosition={myPosition}
          myScore={myScore}
          {...props}
        />
        <TriviaLeaderboardContent leaderboardData={leaderboardData} />
      </Fragment>
    );
  }
}
